import { InjectionToken } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

export const defaultErrors: ValidationErrors = {
  required: () => `This field is required`,
  minLength: ({
    requiredLength,
    actualLength,
  }: {
    requiredLength: number;
    actualLength: number;
  }) =>
    `Minimum characters of ${requiredLength} expected (currently ${actualLength}).`,
  maxlength: ({
    requiredLength,
    actualLength,
  }: {
    requiredLength: number;
    actualLength: number;
  }) =>
    `Maximum characters of ${requiredLength} reached (currently ${actualLength}).`,
  email: () => 'Enter a valid email address.',

  //titleFormatError: () => 'Invalid title. Use Dr., Mr., Mrs., or Ms.',

  pattern: ({ requiredPattern }: { requiredPattern: string }) => {
    switch (requiredPattern) {
      case '/^[^0-9]*$/':
        return 'Only letters and spaces are allowed.';

      case '^(Dr|Mr|Mrs|Ms)$|^[A-Za-z ]+$':
        return 'Invalid title. Use Dr., Mr., Mrs., or Ms.';

      case '/^[A-Za-z0-9-_]+( [A-Za-z0-9-_]+)*$/':
        return 'Only letters and numbers. Underscore or hyphen may be used.';

      case '/^[0-9]{9}$/':
        return 'Device ID must be exactly 9 digits';

      case '/^[\\p{L}\\p{M} \'\\-"]+$/u':
        return 'Only letters, spaces, hyphens, and quotes are allowed.';

      case '/^[0-9+-]*$/':
        return 'Only numbers, plus and minus are allowed.';

      case '/^[A-Za-z0-9]+(?:[_-][A-Za-z0-9]+)*$/u':
        return 'Only letters and numbers. Underscore or hyphen may be used.';

      default:
        return 'Invalid characters used.';
    }
  },
  dateOfBirthBounds: () => 'Date of birth must be between 1900 and today.',
  endDateNotBeforeStartDate: () =>
    'The end date cannot be before the start date.',
  emailsMustMatch: () => 'Emails must match.',
  minSelectedCheckboxes: () => 'Select at least one option.',
  noClinicsAssigned: () => 'No clinics assigned.',
};

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => defaultErrors,
});
